/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import { CampaignType } from "pages/dealScreener/Email/constants";
import { Dialog, DialogContent, CircularProgress } from "@material-ui/core";
import _ from "lodash";

import { PrepaymentPreview, ValuationSensitivityPreview } from "..";

const StyledDialogContent = styled(DialogContent)`&& {
    width: 630px;
    padding: 28px;
    min-height: 350px;
    overflow-x: hidden;
    overflow-y: auto;
    background: #FFFFFF;
    display: flex;
}`;

const IndicatorWrapper = styled.div`
  font-family: Work Sans;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PreviewBase = ({
  logo,
  emailCampaign,
  campaignType,
  open,
  handleClose,
  fetchData
}) => {
  const [data, setData] = useState([]);
  const [errorState, setErrorState] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isPrepaymentCampaign = campaignType === CampaignType.PREPAYMENT.id;
  const isValuationSensitivityCampaign = campaignType === CampaignType.VALUATION_SENSITIVITY.id;
  const isPrepaymentLoading = emailCampaign?.prepaymentLoading ?? false;
  const isValuationSensitivityLoading = emailCampaign?.valuationSensitivityLoading ?? false;

  useEffect(() => {
    if (fetchData) {
      fetchData();
    }
  }, [fetchData]);

  useEffect(() => {
    if (_.isEmpty(emailCampaign)) {
      return;
    }

    if (isPrepaymentCampaign && !isPrepaymentLoading) {
      setIsLoading(false);
      setData(emailCampaign.prepayment);
    }

    if (isValuationSensitivityCampaign && !isValuationSensitivityLoading) {
      setIsLoading(false);
      setData(emailCampaign.valuationSensitivity);
    }

    if (emailCampaign.prepaymentError || emailCampaign.valuationSensitivityError) {
      setIsLoading(false);
      setErrorState(true);
    }

    if (isPrepaymentLoading || isValuationSensitivityLoading) {
      setIsLoading(true);
      setErrorState(false);
      setData([]);
    }
  }, [emailCampaign, isPrepaymentLoading, isValuationSensitivityLoading]);

  const hasData = (Boolean(data.length) || !_.isEmpty(data));
  const isNotLoadingAndHasNoError = !isLoading && !errorState;

  return (
    <Dialog
      open={open}
      autoDetectWindowHeight
      autoScrollBodyContent={false}
      onClose={handleClose}
      maxWidth="md"
    >
      <StyledDialogContent>
        {
          isLoading &&
          <IndicatorWrapper>
            <CircularProgress />
          </IndicatorWrapper>
        }
        {
          !isLoading && errorState &&
          <IndicatorWrapper>Error getting data</IndicatorWrapper>
        }
        {
          !hasData && isNotLoadingAndHasNoError &&
          <IndicatorWrapper>There is no data</IndicatorWrapper>
        }
        {hasData && isNotLoadingAndHasNoError && isPrepaymentCampaign && <PrepaymentPreview data={data} logo={logo} />}
        {hasData && isNotLoadingAndHasNoError && isValuationSensitivityCampaign && <ValuationSensitivityPreview data={{ ...data, logo }} />}
      </StyledDialogContent>
    </Dialog>
  );
};

const mapStateToProps = ({ emailCampaign }) => ({ emailCampaign });

export default compose(connect(mapStateToProps, {}))(PreviewBase);
